import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const PROFILE_OPTIONS = `${BASE_URL}/rest/v1.0/profile`;
